import React from 'react'
import 'whatwg-fetch'

const API_BASE = process.env.NODE_ENV === 'production' ? 'https://api.mrjotto.com' : 'http://localhost:3000'

class Verify extends React.Component {
    constructor(props) {

        super(props)

        const self: any = this
        self.state = { text: 'Verifying...' }
        self.verify = self.verify.bind(self)
    }

    componentWillMount () {
        const { username, verifyCode } = this.props.params
        this.verify(username, verifyCode)
    }

    verify (username, verifyCode) {
        fetch(`${API_BASE}/users/${username}/verify/${verifyCode}`, {
            method: 'GET',
            mode: 'cors',
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result === 'ok') {
                    this.setState({ text: 'Verified!' })
                    setTimeout(() => window.location.href = '/', 800)
                } else {
                    this.setState({ text: 'Error verifying!' })
                }
            })
            .catch(err => this.setState({ text: 'Error verifying' }))
    }

    render() {
        const { text } = this.state

        return (
            <div style={{marginTop: '120px', textAlign: 'center', color: '#fff'}}>
                <h2>{text}</h2>
            </div>
        )
    }
}

export default Verify



/** WEBPACK FOOTER **
 ** ./src/components/Users/Verify.js
 **/